"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEffectAfterMount = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = require("react");
var useEffectAfterMount = function useEffectAfterMount(effect, dependencyList) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (mounted) {
      return effect();
    }
    // mounted and effect is not added purposely - it is to create an interface like useEffect
    // - it doesn't rerun even though the first argument is created on each render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyList);
  return mounted;
};
exports.useEffectAfterMount = useEffectAfterMount;